import React from 'react';
import { motion } from 'framer-motion';

interface CharacterOptionProps {
  name: string;
  image: string;
  onClick: () => void;
}

export const CharacterOption: React.FC<CharacterOptionProps> = ({ name, image, onClick }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="group relative"
      onClick={onClick}
    >
      <div className="aspect-square rounded-xl overflow-hidden bg-red-50 mb-2">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <p className="text-sm font-medium text-gray-700 group-hover:text-red-600 transition-colors">
        {name}
      </p>
    </motion.button>
  );
};